const LocalStorageKey = "subscribe"
/**
 * 根据 Key 获取 LocalStorage 
 * @returns 以 JSON 的形式呈现
 */
 export function getLocalStorage() {
  return JSON.parse(localStorage.getItem(LocalStorageKey))
}

/**
 * 设置 空内容 到 LocalStorage 常用于 初始化
 * @returns 
 */
export function setEmptyContentLocalStorage() {
  localStorage.setItem(LocalStorageKey, JSON.stringify('{}'))
}

/**
 * 根据 Key 删除 LocalStorage
 * @returns
 */
export function removeProjectLocalStorage() {
  return localStorage.removeItem(LocalStorageKey)
}

/**
 * 从 LocalStorage 中获取 Token 数据
 * @returns 
 */
export function getToken() {
  return getLocalStorage() != null ? getLocalStorage().projectToken : null
}

/**
 * 将系统 Token 数据 存放在 LocalStorage 中
 * @param token Token数据
 * @returns 
 */
export function setToken(token) {
  if (getLocalStorage() == null) {
    setEmptyContentLocalStorage()
  }
  const sourceData = getLocalStorage();
  sourceData.projectToken = token
  localStorage.setItem(LocalStorageKey, JSON.stringify(sourceData))
}

/**
 * 将系统 Token 数据从 LocalStorage 删除
 * @returns 
 */
export function removeToken() {
  if (getLocalStorage() == null) {
    setEmptyContentLocalStorage()
  }
  const sourceData = getLocalStorage();
  delete sourceData.projectToken
  localStorage.setItem(LocalStorageKey, JSON.stringify(sourceData))
}

/**
 * 从 LocalStorage 中获取 User 数据
 * @returns 
 */
export function getUser() {
  if (getLocalStorage() == null) {
    return null
  }
  return getLocalStorage().user
}

/**
 * 将用户数据保存在 LocalStorage 中
 * @param user 用户数据
 * @returns 
 */
export function setUser(user) {
  if (getLocalStorage() == null) {
    setEmptyContentLocalStorage()
  }
  const sourceData = getLocalStorage();
  sourceData.user = user
  localStorage.setItem(LocalStorageKey, JSON.stringify(sourceData))
}

/**
 * 将用户数据从 LocalStorage 中删除
 * @returns
 */
export function removeUser() {
  if (getLocalStorage() == null) {
    setEmptyContentLocalStorage()
  }
  const sourceData = getLocalStorage();
  delete sourceData.user
  localStorage.setItem(LocalStorageKey, JSON.stringify(sourceData))
}




// WEBPACK FOOTER //
// ./src/utils/auth.js